// extracted by mini-css-extract-plugin
export var bounce = "LogoFbp-module--bounce--80325";
export var dotMoveLeft = "LogoFbp-module--dot-move-left--45214";
export var dotMoveRight = "LogoFbp-module--dot-move-right--f18e9";
export var gradient = "LogoFbp-module--gradient--69911";
export var image = "LogoFbp-module--image--33ca6";
export var link = "LogoFbp-module--link--fb92c";
export var logo = "LogoFbp-module--logo--e4c08";
export var separatorWidth = "LogoFbp-module--separator-width--dc225";